<template>
  <div class="container">
    <div class="box">
      <div class="boxone">
        <img src="../../../assets/icon/success.png" alt="" />
        <span>订单支付成功</span>
      </div>
      <div class="boxtwo">
        <span>支付方式</span>
        <span>{{ payType }}</span>
        <!-- <span v-if="money == 0">微信支付</span>
        <span v-else>We2000</span> -->
      </div>
      <div class="boxthree" v-if="isGift == null">
        <div class="threeleft">支付金额</div>
        <div class="threeright">
          <span>{{ saleTotalAmount }}积分</span>
          <!-- <span class="discount">已优惠 ￥0</span> -->
        </div>
      </div>
      <div class="boxfour">
        <span class="see" @click="orders()">查看订单</span>

        <span class="continue" v-if="isGift != null" @click="goBackGift()"
          >返回我的奖品</span
        >
        <span class="continue" v-else @click="index()">继续逛逛</span>
      </div>
      <div class="tui-order" v-if="showqy">
      <div class="tui-item-title">商品赠礼:</div>
      <div class="qybox">
        <div class="qyimg">
          <img :src="require('@/assets/images/qy.jpg')" width="60" alt="" />
        </div>
        <div class="qycon">
          <div class="b" @click="qyModel=true">智家会员联合生态卡</div>
          <div>点击领取免费获得付费会员体验卡资格或进入“订单详情页”继续领取使用</div>
        </div>
        <div class="qyimg">
          <van-button
            round
            color="var(--theme-color-main)"
            size="small"
            @click="getCard(parentOrderNo)"
            class="get-btn"
            :disabled="btndis"
            v-if="showbtn"
            >领取</van-button
          >

          <van-button
            round
            color="#eee"
            size="small"
            class="get-btn"
            disabled
            v-else
            >已领取</van-button
          >
        </div>
      </div>
    </div>
    </div>
    
    <!--		<div class="coupon">-->
    <!--			<img src="../../../assets/icon/coupon.png" alt="">-->
    <!--			<p>恭喜你获得<br><span>50</span>元优惠券</p>-->
    <!--		</div>-->
    <!-- <div class="swiper">
      <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
                 <van-swipe-item v-for="item in picList" :key="item.id"> <img src="{{item.pic}}"/></van-swipe-item>
      </van-swipe>
    </div> -->
    <div class="formbox">
    <FormComponent form-type="1" :form-config="formConfig" />
    </div>


    <div class="tips">
      <p>温馨提示：</p>
      <span
        >本平台不会以订单异常，系统升级为由要求您点击任何网址链接进行退款操作。</span
      >
    </div>
    <van-dialog
      v-model="isplus"
      title="开通成功"
      @confirm="goPlus()"
      confirmButtonText="去查看"
      confirmButtonColor="#4b89f8"
      show-cancel-button
    >
      <div class="tui-receiving">
        您已经开通智家PLUS会员，是否前往专属页查看权益？
      </div>
    </van-dialog>
     <van-dialog
      v-model="qyModel"
      title="《智家会员生态联合卡声明》"
      @confirm="qyModel = false"
      theme="round-button"
      confirm-button-color="var(--theme-color-main)"
      confirm-button-text="我知道了"
    >
      <div class="tui-qy">
        <span>业务声明：</span> <br />
        积分商城为向智家会员提供更优质的购物体验，特别推出智家PLUS会员生态联合卡，全方位提升和丰富您在智家APP的购物特权。<br />
        <span>权益介绍及使用规则：</span><br />
        活动期间，在积分商城兑换指定商品可同步开通智家PLUS会员生态联合卡，权益包含专享会员折扣、专享购物卡券、尊享清洗优惠、专属客服服务四大权益。
        具体使用规则请下载智家APP并登录，在我的-PLUS会员中查看和使用。 <br />
        <span>有效期及其他：</span><br />
        智家会员生态联合卡自领取之日起1年内有效，请您合理保存、使用用户名和密码，若发现您的账户有违规行为，智家有权关闭您的PLUS会员开通资格、关停您已开通的PLUS会员服务。
        本活动最终解释权归海尔积分商城所有。<br />
        智家会员生态联合卡每个ID限领取一次，已经开通生态联合卡的用户及智家合伙人、智家客户等非普通用户身份不支持领取。
      </div>
    </van-dialog>
  </div>
</template>

<script>
// import wx from "weixin-js-sdk";
import { haierOrderPay, receiveGivePlus, checkUserGivePlus } from "@/api/api";
import UplusApi from "@uplus/uplus-api";
import { FormComponent } from '@hwork/tduck-form-generator'

export default {
    components:{FormComponent},

  data() {
    return {
      saleTotalAmount: 0,
      parentOrderNo: null,
      isplus: false,
      ip: "",
      instance: new UplusApi(),
      isGift: null,
      payType: "海贝积分",
      btndis: false,
      showqy: false,
      showbtn: true,
      qyModel:false,
      formConfig: {
          mainSceneValue: 'HUIYUAN_0001', // 主场景
          childSceneValue: 'HY06', // 子场景
          nodeValue:'HY0601',  // 行为节点
          checkId:this.$route.query.parentOrderNo,   
          additionalRelId:this.$route.query.parentOrderNo,
      }
    };
  },

  mounted() {
    // if (this.$route.query.number && this.$route.query.number != "") {
    //   this.parentOrderNo = this.$route.query.number;
    //   this.saleTotalAmount = this.$route.query.money;
    // } else {
    //   this.$router.go(-1);
    // }
    this.parentOrderNo = this.$route.query.parentOrderNo;
    this.saleTotalAmount = this.$route.query.saleTotalAmount;
    this.ip = sessionStorage.getItem("Ip")||localStorage.getItem("Ip");
    this.isGift = this.$route.query.applyCode;
    if (this.isGift != null) {
      this.payType = "卡兑换";
    }
    console.log(this.parentOrderNo);
    if (this.$route.query.isPlus == 1) {
      this.isplus = true;
    }
    this.checkCard(this.parentOrderNo);
  },

  // mounted: function (options) {
  //   this.queryPicList();
  //   this.type = this.$route.query.type;
  //   this.money = this.$route.query.money;
  // },
  methods: {
    goPlus() {
      const userAgent = navigator.userAgent.toLocaleLowerCase();

      if (userAgent.includes("uplus") || userAgent.includes("sybird")) {
        this.instance.upVdnModule
          .goToPageForResult({
            url:
              "mpaas://haierVipCode?needAuthLogin=1#/cn/distcord/payingMember",
          })
          .then(
            (res) => {
              console.log("result", res);
            },
            (err) => {
              console.log("err", err);
            }
          );
      } else {
        let params = {
          target: "7a8a25a5466463554fd69d8570fbac41",
          redirect_uri: "https://hzy.haier.com/cn/vipcode/payingMember",
          user_id:
            this.$cookies.get("memberId") || sessionStorage.getItem("memberId"),
          client_ip: this.ip,
          client_agent: navigator.userAgent,
        };
        console.log(params);
        this.$axios({
          url: "https://account-api.haier.net/v2/haier/client/jump",
          // url: "https://testaccount.haier.com/v2/haier/client/jump",
          method: "post",
          data: params,
          headers: {
            Authorization:
              "Bearer " + this.$cookies.get("hbscToken") ||
              sessionStorage.getItem("hbscToken"),
          },
        })
          .then((res) => {
            // return
            console.log(res.data.data);
            window.location.href = res.data.data;
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    index() {
      if (this.$route.query.sources == '11') {
        this.$router.push({
        path: "/washandcareArt",
      });
      }else{
this.$router.push({
        path: "/",
      });
      }
      
    },
    orders() {
      if (this.$route.query.sources == '11') {
        this.$router.push({
        path: "/order?sources=11",
      });
      }else{
this.$router.push({
        path: "/order",
      });
      }
      
    },
    // 查询是否能够领取智家联合卡(
    async checkCard(orderNo) {
      let params = {
        orderNo: null,
        parentOrderNo: orderNo,
        buyerId:
          this.$cookies.get("memberId") || sessionStorage.getItem("memberId"),
      };
      let this_ = this;
      // 0 不允许领取  1 未领取  2 已领取

      let res = await checkUserGivePlus(params);
      if (res.code === "0000") {
        if (res.data != null) {
          if (res.data != "0") {
            this_.showqy = true;
            res.data == "1" ? (this_.showbtn = true) : (this_.showbtn = false);
          }
        }
      }
    },
    // 领取卡
    async getCard(orderNo) {
      this.btndis = true;
      let this_ = this;
      let params = {
        orderNo: null,
        parentOrderNo: orderNo,
        buyerId:
          this.$cookies.get("memberId") || sessionStorage.getItem("memberId"),
      };
      let res = await receiveGivePlus(params);
      if (res.code == "0000") {
        if (res.data == false) {
          this_.$toast(res.msg);
        } else {
          this_.$toast("领取成功");
          this_.showbtn = false;
        }
      }
    },
    // async queryPicList() {
    //   let _this = this;
    //   const param = {
    //     location: 5,
    //   };
    //   const res = await queryByLocation(param);
    //   if (res.code == "0000") {
    //     _this.picList = res.data;
    //     console.log(_this.picList);
    //   } else {
    //     this.$toast(res.msg);
    //   }
    // },
    goBackGift() {
      this.instance.closeH5ContainerView();
    },
  },
};
</script>

<style scoped lang="scss">
.box {
  padding: 0 20px;
  background-color: #fff;

  .boxone {
    padding-top: 50px;
    text-align: center;

    img {
      display: block;
      width: 103px;
      // height: 103px;
      margin: 0 auto;
      padding-bottom: 30px;
    }

    span {
      display: block;
      font-size: 26px;
      color: #333333;
      padding-bottom: 50px;
    }
  }

  .boxtwo {
    padding: 10px 0;
    display: flex;
    border-bottom: 1px solid #f3f3f3;
    flex-flow: row nowrap;
    justify-content: space-between;

    span {
      display: block;
      font-size: 26px;
      color: #333333;
    }
  }

  .boxthree {
    padding: 10px 0;
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: space-between;

    .threeleft {
      font-size: 26px;
    }

    span {
      display: block;
      font-size: 26px;
      color: #333333;
      text-align: right;
    }

    .discount {
      display: block;
      color: #999;
      font-size: 20px;
    }
  }

  .boxfour {
    display: flex;
    padding: 80px 0;
    justify-content: center;
    margin: 0 auto;

    .see {
      display: block;
      width: 250px;
      height: 70px;
      line-height: 70px;
      text-align: center;
      background: #eaeaea;
      border-radius: 35px;
      font-size: 26px;
      color: #999999;
      margin-right: 20px;
    }

    .continue {
      width: 250px;
      height: 70px;
      line-height: 70px;
      text-align: center;
      background: $theme-color-main;
      border-radius: 35px;
      color: #fff;
    }
  }
}
.coupon {
  position: relative;
  padding: 20px 20px 0 20px;
  img {
    width: 100%;
  }
  p {
    position: absolute;
    top: 55%;
    left: 55%;
    transform: translate(-50%, -50%);
    font-size: 42px;
    font-weight: 400;
    color: #666666;
    line-height: 48px;
    span {
      color: red;
    }
  }
}

.swiper {
  padding: 20px;
  .van-swipe-item {
    color: #fff;
    font-size: 20px;
    line-height: 150px;
    text-align: center;
    background-color: #39a9ed;
    height: 255px;
  }
}
.tips {
  padding: 0 20px;
  font-size: 26px;
  margin-top: 20px;
  p {
    color: #333;
  }
  span {
    color: #666;
  }
}
.qybox {
  padding-top: 20px;
  margin-top: 10px;
  border-top: 1px solid #eee;
  display: flex;
  justify-content: space-between;
  .qyimg {
    width: 18%;
  }
  .qycon {
    width: 60%;
  }
  .b {
    color: var(--theme-color-main);
    font-size: 32px;
  }
  .bz {
    color: #999;
    font-size: 0.25rem;
  }
  .get-btn {
    width: 110px;
    height: 50px;
    margin-top: 40px;
  }
}
.tui-qy {
  padding: 30px 50px;
  color: #999999;
  font-size: 0.3rem;
  text-align: left;
  line-height: 0.5rem;
  span {
    font-size: 0.35rem;
    color: #000;
  }
}
.formbox{
  background-color: #fff;
  margin-top: 20px;
}
</style>
